import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { WithdrawStackRoutes, WithdrawStackScreenProps } from './type';
import { WithdrawWebPlacedScreen } from './WithdrawWebPlaced.screen';
import { WithdrawNativePlacedScreen } from './WithdrawNativePlaced.screen';

export interface NewAccountProps {}
export const WithdrawPlaced: React.FC<WithdrawStackScreenProps<WithdrawStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, data, returnData, refresh, record } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <WithdrawNativePlacedScreen onClose={onGoBack} data={data} returnData={returnData} refresh={refresh} record={record} />;
  }

  return (
    <WithdrawWebPlacedScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      returnData={returnData}
      refresh={refresh}
      record={record}
    />
  );
};
